import React, { useEffect, useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  numberWithCommas,
  setAdditionalClasses,
} from "../assets/js/utils";
import useCounterAnimation from "./hooks/useCounterAnimation";

function Counter({
  enableVisibilityAnimation = true,
  value,
  unit,
  applyValueClassName,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const counterRef = useRef();

  useCounterAnimation(counterRef, value, isVisible);

  const handleVisibility = (visible) => {
    setIsVisible(visible);
  };
  // useEffect(() => {
  //   if (counterRef.current) {
  //     const number = numberWithCommas(value);
  //     let result = "";
  //     for (let i = 0; i < number.length; i++) {
  //       result += `<span style="--i:${i + 1}">${number[i]}</span>`;
  //     }
  //     counterRef.current.innerHTML = `<span class="waviy">${result}</span>`;
  //   }
  // });
  return (
    <VisibilitySensor partialVisibility onChange={handleVisibility}>
      <span
        className="counter"
        style={
          enableVisibilityAnimation
            ? getVisibleSensorAnimation(isVisible, "fadeIn 1s")
            : {}
        }
      >
        <span
          ref={counterRef}
          className={`counter__value${setAdditionalClasses(
            [applyValueClassName],
            [applyValueClassName]
          )}`}
        >
          {value}
        </span>
        {unit && <span className="counter__unit">{unit}</span>}
      </span>
    </VisibilitySensor>
  );
}

export default Counter;
